<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'SUBSCRIPTIONS.MANAGE_TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'ADMINISTRATION.PAGE_TITLE' | translate"
        [previousPageUrl]="'/settings'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <div class="my-plan-container row">
      <div class="col-xs-12 col-md-12" *ngIf="cards$ | async as cards; else loadingCards">
        <app-current-plan
          [detailsUrl]="'/upgrade'"
          [detailsTextKey]="'SUBSCRIPTIONS.COMPARE_PLANS'"
          [showAction]="true"
        ></app-current-plan>
        <app-subscription-card *ngFor="let card of cards" [cardData]="card"></app-subscription-card>
      </div>
      <ng-template #loadingCards>
        <div class="col-xs-12 col-md-12">
          <app-subscription-card
            *ngFor="let card of defaultSubscriptionCardData"
            [cardData]="card"
          ></app-subscription-card>
        </div>
      </ng-template>
    </div>
  </glxy-page-wrapper>
</glxy-page>
